import { Action } from '@ngrx/store';


export const SELECT_ROOM = '[Rooms] Select Room';
export const INCLUDE_SOWETO_TOUR = '[Rooms] Include Soweto Tour';
export const INCLUDE_UNION_BUILDING_TOUR = '[Rooms] Include Union Building Tour';
export const INCLUDE_SUN_CITY_TOUR = '[Rooms] Include Sun City Tour';
export const INCLUDE_GOLD_REEF_CITY_TOUR = '[Rooms] Include Gold Reef City Tour';

export const EXCLUDE_SOWETO_TOUR = '[Rooms] Exclude Soweto Tour';
export const EXCLUDE_UNION_BUILDING_TOUR = '[Rooms] Exclude Union Building Tour';
export const EXCLUDE_SUN_CITY_TOUR = '[Rooms] Exclude Sun City Tour';
export const EXCLUDE_GOLD_REEF_CITY_TOUR = '[Rooms] Exclude Gold Reef City Tour';




export class SelectRoom implements Action {
    readonly type = SELECT_ROOM;
    constructor(public payload: string) {}
}

export class IncludeSowetoTour implements Action {
    readonly type = INCLUDE_SOWETO_TOUR;
}

export class IncludeUnionBuildingTour implements Action {
    readonly type = INCLUDE_UNION_BUILDING_TOUR;
}

export class IncludeSunCityTour implements Action {
    readonly type = INCLUDE_SUN_CITY_TOUR;
}

export class IncludeGoldReefCityTour implements Action {
    readonly type = INCLUDE_GOLD_REEF_CITY_TOUR;
}

export class ExcludeSowetoTour implements Action {
    readonly type = EXCLUDE_SOWETO_TOUR;
}

export class ExcludeUnionBuildingTour implements Action {
    readonly type = EXCLUDE_UNION_BUILDING_TOUR;
}

export class ExcludeSunCityTour implements Action {
    readonly type = EXCLUDE_SUN_CITY_TOUR;
}

export class ExcludeGoldReefCityTour implements Action {
    readonly type = EXCLUDE_GOLD_REEF_CITY_TOUR;
}


export type roomActions = SelectRoom |
                         IncludeSowetoTour |
                         IncludeUnionBuildingTour |
                         IncludeSunCityTour |
                         IncludeGoldReefCityTour |

                         ExcludeSowetoTour |
                         ExcludeUnionBuildingTour |
                         ExcludeSunCityTour |
                         ExcludeGoldReefCityTour;



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/store/actions/rooms.action.ts